import { IonButton } from '@ionic/react';

import { Box, Stack } from '@/components/Elements';
import { Heading, Text } from '@/components/Typography';

export const UpgradableTicket = () => {
  const onTicketClicked = () => {};
  return (
    <Box
      display="flex"
      flexDirection="column"
      width="full"
      borderRadius="rounded-lg"
      borderColor="gray-300"
      borderStyle="solid"
      borderWidth="px"
      padding="4x"
      color="white"
      overflow="hidden"
    >
      <Heading variant="h1" textAlign="left">
        <Text color="gray-700" fontSize="2xl">
          Single day ticket
        </Text>
      </Heading>

      <Text marginTop="1x" color="gray-700" fontSize="base">
        Jessica Lai • Sunday, Feb 3 2023
      </Text>

      <Text color="gray-700" fontSize="base">
        Seaworld Orlando
      </Text>

      <Stack
        flexDirection="row"
        cellSpacing="2x"
        justifyContent="space-between"
        alignItems="center"
        marginTop="1x"
        width="full"
      >
        <Stack flexDirection="column">
          <Text color="gray-700" fontSize="base">
            Ticket purchase price
          </Text>

          <Text color="gray-700" fontSize="base">
            $999.99
          </Text>
        </Stack>

        <IonButton onClick={onTicketClicked}>Update</IonButton>
      </Stack>
    </Box>
  );
};
